import { useQuery } from "@apollo/client";
import { useEffect } from "react";
import { useAppConfigStore } from "~/stores/appConfigStore";
import { GET_APP_CONFIG } from "../../api";

export const useGetAppConfig = () => {
  const setAppConfig = useAppConfigStore((s) => s.setAppConfig);
  const {
    data: { getAppConfig } = {},
    loading,
    error,
  } = useQuery(GET_APP_CONFIG, {
    fetchPolicy: "cache-and-network",
  });

  useEffect(() => {
    if (!loading && getAppConfig?.features) {
      setAppConfig({
        features: getAppConfig.features,
        plans: getAppConfig.plans,
      });
    }
  }, [loading, getAppConfig, setAppConfig]);

  return {
    appConfig: getAppConfig,
    loading,
    error,
  };
};
